import * as Rx from 'rxjs';
import * as RxOp from 'rxjs/operators';
import * as R from 'ramda';

import {
  fetchDrawerHistories,
  fetchDrawerHistoryFilterOptions,
} from '../../utils/api/client';
import { getPosApiUrl, getAccessToken } from '../../utils/state';
import { getFiltersFromFields } from '../../utils/helpers';
import {
  FETCH_DRAWER_HISTORIES_REQUEST,
  fetchDrawerHistoriesSuccess,
  drawerHistoryIndexAlertBarAction,
  fetchDrawerHistoriesError,
} from './DrawerHistoryIndex.state';
import { caughtError } from '../../utils/api/errorHandler';
import {
  FETCH_DRAWER_HISTORIES_FILTER_OPTIONS,
  fetchDrawerHistoriesFilterOptionsSuccess,
  fetchDrawerHistoriesFilterOptionsError,
} from '../../state/shared';

const caughtDrawerHistoryErrorCallback = (state) =>
  caughtError(
    drawerHistoryIndexAlertBarAction,
    'Drawer History Page Error:',
    state,
  );

const getDrawerHistoryIndexFiltersParam = (state) => {
  const filterFields = R.pathOr(
    [],
    ['drawerHistoryIndex', 'forms', 'drawerHistoryFiltersForm'],
    state,
  );

  return getFiltersFromFields(filterFields);
};

const fetchDrawerHistoriesParams = (state) => ({
  url: getPosApiUrl(state),
  token: getAccessToken(state),
  pageIndex: state.drawerHistoryIndex.currentPage,
  pageSize: state.drawerHistoryIndex.pageSize,
  filters: getDrawerHistoryIndexFiltersParam(state),
});

export const fetchDrawerHistoriesEpic = (action$, state$) =>
  action$.ofType(FETCH_DRAWER_HISTORIES_REQUEST).pipe(
    RxOp.switchMap(() =>
      Rx.from(
        fetchDrawerHistories(fetchDrawerHistoriesParams(state$.value)),
      ).pipe(
        RxOp.flatMap((response) =>
          Rx.of(fetchDrawerHistoriesSuccess(response)),
        ),
        RxOp.catchError((err) =>
          caughtDrawerHistoryErrorCallback(state$.value)(
            err,
            fetchDrawerHistoriesError(err.message),
          ),
        ),
      ),
    ),
  );

export const fetchDrawerHistoriesFilterOptionsEpic = (action$, state$) =>
  action$.ofType(FETCH_DRAWER_HISTORIES_FILTER_OPTIONS).pipe(
    RxOp.flatMap(() =>
      Rx.from(
        fetchDrawerHistoryFilterOptions(
          fetchDrawerHistoriesParams(state$.value),
        ),
      ).pipe(
        RxOp.flatMap((response) =>
          Rx.of(fetchDrawerHistoriesFilterOptionsSuccess(response)),
        ),
        RxOp.catchError((err) =>
          caughtDrawerHistoryErrorCallback(state$.value)(
            err,
            fetchDrawerHistoriesFilterOptionsError(err.message),
          ),
        ),
      ),
    ),
  );
